module.exports = __webpack_public_path__ + "static/media/company.863eb056.svg";